import React from 'react';
import './styles.scss';

import { getProfilePhoto } from '../../helpers/image'

interface IProptype {
  name: string
  email: string
  picture?: string
  style?: object
  className?: string
}

export default function UserInfoRow({name, email, picture, className = '', style }: IProptype) {
  
  return (
    <div 
    style={style}
    className={`user-info-container ${className}`}>
      <div className="image-container">
        <img 
        src={getProfilePhoto(picture, name)} 
        alt={`imagem de perfil de ${name}`} 
        />
      </div>
      <div className="info-container">
        <span className="name">{name}</span>
        <span className="email">{email}</span>
      </div>
    </div>
  )
}
